import { Spacer } from '@zillow/constellation';
import { Paragraph, Text } from '@zillow/constellation-10';

type Props = {
  outcomeStats?: number;
  source?: string;
};

const WizardTipContent = ({ outcomeStats = 0, source = '' }: Props) => {
  return (
    <div data-testid="WizardTipContent">
      {outcomeStats !== 0 && source !== '' ? (
        <>
          <Paragraph css={{ marginBottom: '200' }}>
            Displaying the property address can result in receiving up to {outcomeStats}% more contacts, based on data
            for similarly priced properties.
          </Paragraph>
          <Paragraph>You can choose to hide it if privacy is a concern.</Paragraph>

          <Spacer marginY="sm">
            <Text textStyle="body-xs" css={{ color: 'text.subtle' }}>
              {source}
            </Text>
          </Spacer>
        </>
      ) : (
        <Paragraph>
          You can hide the address if privacy is a concern, but the listing may receive fewer views and contacts than
          listings that show the property address.
        </Paragraph>
      )}
    </div>
  );
};

export default WizardTipContent;
